import { h } from 'vue';

import { useGrid } from '../composable';

import type { IGridProps } from '../types';
import type { SetupContext } from 'vue';

export function FlexGrid(props: IGridProps, context: SetupContext) {
  const { prefix } = useGrid();

  return () =>
    h(
      props.tag,
      {
        class: {
          [`${prefix}-grid`]: true,
          [`${prefix}-grid-condensed`]: props.condensed,
          [`${prefix}-grid-narrow`]: props.narrow,
          [`${prefix}-grid--wide`]: props.wide
        }
      },
      context.slots.default && context.slots.default()
    );
}

import './FlexGrid.scss';
